// #350: o perfil pode declarar em quais gerências vale. Escopo vazio vale em
// TODAS — é o estado dos 4 perfis de produção, e é o que faz a tela seguir
// funcionando sem ninguém configurar nada.
//
// Este predicado só decide o que a tela OFERECE. A recusa de verdade é do
// servidor (`validaEscopoDePerfil`), porque regra que só existe no seletor é
// contornável por POST direto — foi o que aconteceu com `perfil.ativo`.
export default function perfilValeNaGerencia(perfil, gerenciaId) {
  // Se gerencias for malformado (não-array, mas truthy), degrada para vazio
  // em vez de estourar TypeError. Mantém os dois lados falhando da mesma forma.
  const escopo = Array.isArray(perfil && perfil.gerencias)
    ? perfil.gerencias
    : [];
  if (escopo.length === 0) return true;
  if (gerenciaId === null || gerenciaId === undefined || gerenciaId === '') {
    return false;
  }
  const numId = Number(gerenciaId);
  // Garanta que um id não numérico nunca case com um NaN do escopo malformado.
  // .includes(NaN) bateria porque usa SameValueZero (NaN === NaN), abrindo
  // acesso incorretamente.
  if (isNaN(numId)) {
    return false;
  }
  return escopo.map(Number).includes(numId);
}
